/** td-logger is a logging utility that is enabled by passing the
 * loggingEnabled prop to the WebSDK exported component.
 * Should NOT be enabled on production environments.
 */

import env from "./env";

/**
 * Runs console if logging is enabled.
 * @param {string} functionName - The name of the function where the logger is called.
 * @param {object/string} data - Additional data to log. Can be an object or a string.
 */
export const tdLog = (functionName, data = null) => {
  try {
    const loggingEnabled = env("LOGGING_ENABLED");

    if (loggingEnabled === true) {
      if (data === null) {
        // console.trace(`TDLog: ${functionName}`)
        // eslint-disable-next-line no-console
        console.log(`TDLog: ${functionName}`);
      } else {
        // eslint-disable-next-line no-console
        console.log(`TDLog: ${functionName}`, data);
      }
    }
  } finally {
    // silently fail
  }
};
